import React from 'react';
import Toggle from '../Utilities/Toggle';

export default class Missing extends React.PureComponent {

    state = {
        audioMandatoryMissing: [],
        videoMandatoryMissing: [],
        rawDevices: [],
        rawScreenDevices: []
    }

    listeners = []

    async componentDidMount() {

        let rawScreenDevices = window.sdk.videoconf().getScreenDevices();

        this.listeners.push(window.sdk.event().on('availableRemoteDevices', async (devices) => {
            console.log('availableRemoteDevices', devices);
            let rawDevices = await window.sdk.videoconf().getSpecificDevices();
            let { audioMandatoryMissing, videoMandatoryMissing } = devices;
            audioMandatoryMissing = audioMandatoryMissing || [];
            videoMandatoryMissing = videoMandatoryMissing || [];
            this.setState({
                audioMandatoryMissing, videoMandatoryMissing, rawDevices, rawScreenDevices,
            })
        }));

        this.listeners.push(window.sdk.event().on('deviceChange', () => {
            if (window.sdk.session().isPatient())
                this.processDevice();
        }));

        this.listeners.push(window.sdk.event().on('refreshDevices', () => {
            if (window.sdk.session().isPatient())
                this.processDevice();
        }));

        if (window.sdk.session().isPatient()) {
            this.processDevice();
        }

        setTimeout(() => {
            this.processDevice();
        }, 1000);

    }

    async processDevice() {
        let rawDevices = await window.sdk.videoconf().getSpecificDevices();
        let rawScreenDevices = window.sdk.videoconf().getScreenDevices();

        let { audioMandatoryMissing, videoMandatoryMissing } = await window.sdk.videoconf().getDevices();
        audioMandatoryMissing = audioMandatoryMissing || [];
        videoMandatoryMissing = videoMandatoryMissing || [];
        this.setState({
            audioMandatoryMissing, videoMandatoryMissing, rawDevices, rawScreenDevices
        })
    }

    componentWillUnmount() {
        for (var i in this.listeners) {
            this.listeners[i]();
        }
    }

    render() {
        let audioMandatoryMissing = [...this.state.audioMandatoryMissing];
        let videoMandatoryMissing = [...this.state.videoMandatoryMissing];
        for (var i = 0; i < this.state.rawDevices.length; i++) {
            var device = this.state.rawDevices[i];
            var slug = device.slug;
            audioMandatoryMissing = audioMandatoryMissing.filter(audioDevice => audioDevice.slug !== slug);
            videoMandatoryMissing = videoMandatoryMissing.filter(audioDevice => audioDevice.slug !== slug);
        }

        audioMandatoryMissing = Array.from(new Set(audioMandatoryMissing.map(device => device.slug))).map(slug => audioMandatoryMissing.find(device => device.slug === slug));
        videoMandatoryMissing = Array.from(new Set(videoMandatoryMissing.map(device => device.slug))).map(slug => videoMandatoryMissing.find(device => device.slug === slug));

        console.log('devicesList1', audioMandatoryMissing, videoMandatoryMissing)

        const devicesList = this.state.rawDevices.map(item => ({ ...item, status: 'ready', icon: 'check' }))
            .concat(this.state.rawScreenDevices.map(item => ({ ...item, status: 'undefined', icon: 'exclamation' })))
            .concat(audioMandatoryMissing.map(item => ({ ...item, status: 'disabled', icon: 'cancel' })))
            .concat(videoMandatoryMissing.map(item => ({ ...item, status: 'disabled', icon: 'cancel' })))
            .sort((a, b) => a.order - b.order);

        console.log('devicesList2', devicesList)


        return (
            <div className="test-device__capteurs">
                {devicesList.map((device, i) => (
                    <div className={`capteur-item test-device__capteur capteur-item--${device.status} capteur-show capteur-role-${device.slug}`} key={i}>
                        <span className="device-item-icon capteur-item__icon">
                        {/* <i className={`${device.slug === 'otoscope-screen' || device.slug === 'otoscope-webcam' ? 'icon-otoscope' : 'icon-'+device.slug}`}></i> */}
                            <i className={'icon-'+device.role.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(' ','-')}></i>
                        </span>
                        <span className="capteur-item__name">{device.role}</span>
                        <span className="capteur-item__status">
                            <i className={`icon-${device.icon}`} />
                        </span>
                        <div className='capteur-item__toggle'>
                            {/* <Toggle /> */}
                        </div>
                    </div>
                ))}
                {this.props.onClick !== undefined && (
                    <div className={`capteur-item test-device__capteur capteur-item--ready capteur-show capteur-role-doc2u`}>
                        <span className="capteur-item__icon">
                            <i className={`icon-doc2u`}></i>
                        </span>
                        <span className="capteur-item__name">Multicapteur</span>
                        <span className="capteur-item__status">
                            <i className={`icon-check`} />
                        </span>
                        <div className='capteur-item__toggle'>
                            <Toggle status={this.props.status} onClick={this.props.onClick} />
                        </div>
                    </div>
                )}
            </div>
        )
    }
}
